import { AbstractModel } from "./abstract-model";

/**
 */
export abstract class AbstractObject {

    /**
     * Inicializálja az objektumot (belemásolja a paraméterben megadott adatstruktúra értékeit).
     * Minden származtatott osztály konstruktorában szerepelnie kell!
     * Csak akkor érhető el, ha 'new'-val példányosított az osztály.
     */
    protected init?(data: any, target: AbstractObject): void {
        if (data) {
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }
            Object.assign(target, data);
        }
    }
}